module.exports = __webpack_public_path__ + "static/media/screen-facebook-tiloli.d67a7aec.png";